import { useQuery } from '@cbgms/base/http/use-query'
import { getActiveModules } from 'app/auth/state/reducers/shop'
import { useCurrentShop } from 'app/shops/hooks/use-current-shop'

export const ONBOARDING_CACHE_KEY = 'ONBOARDING'
export const WHOLESALER_CACHE_KEY = 'WHOLESALER'

const getExistingShopCacheKey = (shopID: string) => [ONBOARDING_CACHE_KEY, WHOLESALER_CACHE_KEY, shopID]

export const useGetOnboardingExistingShop = (shopID?: string) => {
  const { data: currentShop } = useCurrentShop()
  const result = useQuery(
    getExistingShopCacheKey(shopID || ''),
    async () => {
      if (!shopID || !currentShop) {
        return null
      }

      const modules = getActiveModules(currentShop)
      return { modules, shop: { Data: currentShop } }
    },
    // don't garbage collect for 4 hours after useQuery becomes inactive
    { refetchOnWindowFocus: false, cacheTime: 240 * 60 * 1000, enabled: !!currentShop }
  )

  return result
}
